import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { Routes, Route } from 'react-router-dom';

import './Styles/Fonts.css';
import './Styles/Others.css';
import store from '@Store';
import themes, { THEME_TYPES } from '@Styles/Themes';
import GlobalStyles from '@Styles/GlobalStyles';

import MobileHome from '@Pages/MobileHome';
import ProjectSetting from '@Pages/ProjectSetting';
import Editor from '@Pages/Editor';
import Login from '@Pages/Login';

import Profile from '@Pages/Profile';

import Nickname from '@Pages/Nickname';
import NotFound from '@Components/Common/ErrorBoundary/NotFound';

const App = () => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  return (
    <Provider store={store}>
      <ThemeProvider theme={themes[THEME_TYPES.LIGHT]}>
        <GlobalStyles />

        <Routes>
          {isMobile ? (
            <Route path="*" element={<MobileHome />} />
          ) : (
            <>
              <Route path="*" element={<NotFound />} />
              <Route path="/" element={<Profile />} />
              <Route path="/login" element={<Login />} />
              <Route path="/editor" element={<Editor />} />

              <Route path="/nickname" element={<Nickname />} />
              <Route path="/project_setting" element={<ProjectSetting />} />
            </>
          )}
        </Routes>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
